import { colors } from "@procore/core-react";
export const HEADER_BORDER = `1px solid ${colors.gray90}`;
